import SearchService from './SearchService';

import { UNITS } from '../constants/units';

const defaultBike = new SearchService().defaultBike();

export default class Filter {
    constructor(height = defaultBike.height, unit = UNITS.default, folder = defaultBike.folder) {
        this.height = height;
        this.unit = unit;
        this.folder = folder
    }
};


// WEBPACK FOOTER //
// ./src/classes/Filter.js